(function($) {
 /*
  $('#agree:checkbox').change(function() {
    checkDsgvo();
  });
  
  function checkDsgvo() {
    $('#btn-checkout').prop('disabled', !hasAgreed());
  }
  
  function hasAgreed(){
  	return $('#agree').is(':checked');
  }
  
  checkDsgvo();
  */
  $("#btn-checkout").click(function(e){
    e.preventDefault();
    
    var postalval = $(".order-delivery-date-postalcode").val();
    if(postalval == "" || $('.uiDeliveryDateVal').val() == '' || $('.uiDeliveryDateVal').val() == undefined){
     	$(".identixweb-order-delivery-date-deliveryRequired").show();
     	$(".order-delivery-date-postalcode").addClass("red_brd");
      	return false;
    } else {
    	$(".identixweb-order-delivery-date-deliveryRequired").hide();
      	$(".order-delivery-date-postalcode").removeClass("red_brd");
    }
	var check = $('#agree').is(':checked');
    if(check == false){
     $("#agree_text").show(); 
      $(".agree_p").addClass("red_brd");
    } else {
     $("#agree_text").hide(); 
      $(".agree_p").removeClass("red_brd");
     window.open("/checkout", "_self");
    }
  });
  
  $("#agree").click(function(){
    if($(this).is(':checked') == true){
     $("#agree_text").hide(); 
      $(".agree_p").removeClass("red_brd");
    }
  });

  
  $('.page-gallery .gallery').magnificPopup({
        delegate: 'a', // the selector for gallery item
        type: 'image',
        gallery: {
          enabled:true
        }
    });
  
}) (window.wetheme.$);